import ShopifyAppDrawer from 'modules/apps/apps/ShopifyApp/drawers/ShopifyAppDrawer';
import ShopifyConnectDrawer from 'modules/apps/apps/ShopifyApp/drawers/ShopifyConnectDrawer';

const drawers = [ShopifyAppDrawer, ShopifyConnectDrawer];

export default drawers;
